import PersonalInfoWrapper from 'features/reactivation/screens/PersonalInfo/PersonalInfoWrapper';
import React from 'react';

export default function ReactivationPersonalInfoPage() {
  return <PersonalInfoWrapper />;
}
